export const VENDOR_PAGE_ACCESS_GROUPS = [
  {
    key: 'plan_premium',
    label: 'My Plan',
    items: [
      { key: 'feature_analytics', label: 'Advanced Analytics', paths: ['/vendor/advanced-analytics'] },
      { key: 'feature_custom_branding', label: 'Custom Branding', paths: ['/vendor/branding'] },
      { key: 'feature_priority_support', label: 'Priority Support', paths: ['/vendor/support-tickets'] },
      { key: 'feature_advanced_booking', label: 'Advanced Booking', paths: ['/vendor/advanced-bookings'] },
      { key: 'feature_multi_location', label: 'Multi-Location', paths: ['/vendor/locations'] },
    ],
  },
  {
    key: 'plan_business',
    label: 'Profile & Business',
    items: [{ key: 'page_profile', label: 'Profile', paths: ['/vendor/profile'] }],
  },
  {
    key: 'plan_services',
    label: 'Services',
    items: [
      { key: 'page_services', label: 'Services', paths: ['/vendor/services'] },
      { key: 'page_packages', label: 'Packages', paths: ['/vendor/packages'] },
    ],
  },
  {
    key: 'plan_bookings',
    label: 'Bookings',
    items: [
      { key: 'page_bookings', label: 'Bookings', paths: ['/vendor/bookings'] },
      { key: 'page_consultations', label: 'Consultations', paths: ['/vendor/consultations'] },
      { key: 'page_calendar', label: 'Calendar', paths: ['/vendor/calendar'] },
    ],
  },
  {
    key: 'plan_media',
    label: 'Portfolio & Media',
    items: [
      { key: 'page_portfolio', label: 'Portfolio', paths: ['/vendor/portfolio'] },
      { key: 'page_gallery', label: 'Photo Gallery', paths: ['/vendor/gallery'] },
    ],
  },
  {
    key: 'plan_financial',
    label: 'Financial',
    items: [
      { key: 'page_earnings', label: 'Earnings', paths: ['/vendor/earnings'] },
      { key: 'page_payments', label: 'Payments', paths: ['/vendor/payments', '/vendor/payout-disbursements'] },
      { key: 'page_discount_codes', label: 'Discount Codes', paths: ['/vendor/discount-codes'] },
      { key: 'page_invoices', label: 'Invoices', paths: ['/vendor/invoices'] },
    ],
  },
  {
    key: 'plan_analytics',
    label: 'Analytics',
    items: [
      { key: 'page_analytics', label: 'Analytics', paths: ['/vendor/analytics'] },
      { key: 'page_performance', label: 'Performance', paths: ['/vendor/performance'] },
      { key: 'page_reports', label: 'Reports', paths: ['/vendor/reports'] },
    ],
  },
  {
    key: 'plan_communication',
    label: 'Communication',
    items: [
      { key: 'page_messages', label: 'Messages', paths: ['/vendor/messages'] },
      { key: 'page_notifications', label: 'Notifications', paths: ['/vendor/notifications'] },
      { key: 'page_reviews', label: 'Reviews', paths: ['/vendor/reviews'] },
    ],
  },
  {
    key: 'plan_support',
    label: 'Support and Contact',
    items: [{ key: 'page_support', label: 'Support', paths: ['/vendor/support'] }],
  },
  {
    key: 'plan_settings',
    label: 'Settings',
    items: [
      { key: 'page_security', label: 'Security', paths: ['/vendor/security'] },
      { key: 'page_account', label: 'Account', paths: ['/vendor/account'] },
      { key: 'page_preferences', label: 'Preferences', paths: ['/vendor/preferences'] },
    ],
  },
];

export const VENDOR_PAGE_ACCESS_OPTIONS = VENDOR_PAGE_ACCESS_GROUPS.flatMap((group) => group.items);

const CORE_ALWAYS_ALLOWED_PATHS = ['/vendor'];
const CORE_ALWAYS_ALLOWED_PREFIXES = ['/vendor/subscription', '/vendor/verification'];

/** Paths vendors can open without an active subscription */
export const SUBSCRIPTION_EXEMPT_PREFIXES = [
  '/vendor/subscription',
  '/vendor/verification',
];

export function isSubscriptionExemptPath(pathname = '') {
  const normalized = pathname.split('?')[0];
  return SUBSCRIPTION_EXEMPT_PREFIXES.some(
    (path) => normalized === path || normalized.startsWith(`${path}/`)
  );
}

export function resolvePlanAccessKeyFromPath(pathname = '') {
  const normalizedPath = pathname.split('?')[0];
  const match = VENDOR_PAGE_ACCESS_OPTIONS.find((option) =>
    option.paths.some((path) => normalizedPath === path || normalizedPath.startsWith(`${path}/`))
  );
  return match?.key || null;
}

export function isCoreVendorPath(pathname = '') {
  if (CORE_ALWAYS_ALLOWED_PATHS.includes(pathname)) {
    return true;
  }
  return CORE_ALWAYS_ALLOWED_PREFIXES.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

export function isVendorPathAllowed(pathname, vendorPageAccess, hasActiveSubscription = true) {
  if (!pathname?.startsWith('/vendor')) return true;
  if (isSubscriptionExemptPath(pathname)) return true;
  if (!hasActiveSubscription) return false;
  if (isCoreVendorPath(pathname)) return true;

  const accessKey = resolvePlanAccessKeyFromPath(pathname);
  if (!accessKey) return true;

  return planAllowsPageKey(vendorPageAccess, accessKey);
}

/**
 * Whether the subscription's vendor_page_access allows a given feature key (e.g. page_consultations).
 * Empty/null access list means no restriction (legacy / full access).
 */
export function planAllowsPageKey(vendorPageAccess, accessKey) {
  if (!accessKey) return true;
  if (!Array.isArray(vendorPageAccess) || vendorPageAccess.length === 0) {
    return true;
  }
  return vendorPageAccess.includes(accessKey);
}

